export const BODY_ID = 'body';
export const DESKTOP_NAV_ID = 'desktop-nav';
